<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <mat-card appearance="outlined" style="margin-top: 30px">
        <mat-card-header></mat-card-header>
        <mat-card-content>
          <p-message severity="warn" icon="pi pi-exclamation-triangle">
            @if (forbiddenType === 'disabled') {
              This feature is unavailable for your account, please contact your Customer Success Manager to enable this feature
            } @else if (forbiddenType === 'forbidden') {
              Restricted Access. Please contact your admin to update your role with View permissions
            }
          </p-message>
          @if (module === 'promessaging' || module === 'messagingautomation' || module === 'messagingtemplate' || module === 'promessagingreports') {
            <div>
              <h3>
                Pro Business SMS is TeleGo’s premium SMS service. With Pro Business SMS you’ll get:
              </h3>
              <ul>
                <li>Access for multiple numbers and unlimited users</li>
                <li>The ability to create and send automated custom replies for incoming messages</li>
                <li>The ability to create custom templates that are easily accessible within the chat function within
                  your
                  Customer Portal
                </li>
                <li>Reporting based on all SMS messaging activity</li>
                <li>The option to receive email notifications when there is a new unread message in your Customer
                  Portal.
                  You can also choose to receive the actual content of incoming SMS messages sent to you in an email.
                </li>
              </ul>
              <p>To learn more, please contact your Customer Success Manager.</p>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
